<div class="config-loading" *ngIf="!configLoaded">
    <div class="k-i-loading"></div>
</div>

<section class="config-section" *ngIf="configLoaded">
    <h3 class="config-section-title">
        Optimization Schedule Override
        <span class="config-counter">{{ totalOptimizationDays }} day{{ totalOptimizationDays === 1 ? '' : 's' }} will be optimized tonight</span>
    </h3>
    <p>* This will only apply to the next overnight optimization</p>

    <div class="config-setting">
        <label class="config-label">Days Prior to Optimize</label>
        <kendo-multiselect #optimizationDaysMultiSelect
                           class="config-control filter-drop-down optimization-days-select"
                           [data]="optimizationScheduleDays"
                           [textField]="'label'"
                           [valueField]="'value'"
                           [valuePrimitive]="true"
                           [(ngModel)]="optimizationScheduleSelectedDays"
                           [filterable]="true"
                           (filterChange)="handleFilterOptimizationDays($event)"
                           [autoClose]="false"></kendo-multiselect>
    </div>
</section>

<div class="config-actions" *ngIf="configLoaded">
    <button kendoButton [primary]="true" [disabled]="saving" (click)="onSave()">
        <span *ngIf="saving" class="k-i-loading saving-icon"></span>{{ saving ? 'Saving...' : 'Save' }}
    </button>
</div>
